// src/components/cab/CabFooterUE.jsx
// Footer de confiance « Données hébergées en UE » — une seule source.
// Le texte vit dans UN span : en items flex séparés, il wrappait en
// colonnes disgracieuses sur mobile (bug corrigé en PR #67, qui survivait
// dans les copies de DossiersPanel / DossierDetailScreen / SettingsPanel).

import { cab as K, fonts as F } from '../../theme';

const shieldCheck = (
  <svg viewBox="0 0 24 24" fill="none" style={{ width: 15, height: 15 }}>
    <path d="M12 2 4 6v6c0 5 3.5 8 8 10 4.5-2 8-5 8-10V6z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="m9 12 2 2 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function CabFooterUE({ style }) {
  return (
    <footer style={{
      paddingTop: 22, borderTop: `1px solid ${K.hair}`,
      display: 'flex', alignItems: 'center', gap: 9,
      fontFamily: F.sans, fontSize: 12.5, color: K.ink3,
      ...style,
    }}>
      <span style={{ color: K.verified, display: 'flex', flexShrink: 0, width: 15, height: 15 }} aria-hidden="true">
        {shieldCheck}
      </span>
      <span style={{ lineHeight: 1.5 }}>
        Données hébergées en <b style={{ color: K.ink2, fontWeight: 600 }}>Union européenne</b> · chiffrement de bout en bout · conformité RGPD
      </span>
    </footer>
  );
}
